import React, { createContext, useState, ReactChild, useContext, useEffect } from 'react';
import LockScreen from 'popups/LockScreen';
import { setClients } from 'scripts/clients/index';

import * as interfaces from 'interfaces';

export const ClientContext = createContext({
  client: {} as interfaces.ClientInterface,
  setClient: (c: interfaces.ClientInterface) => { },
  categories: [] as string[],
  setCategories: (c: string[]) => { },
  questions: [] as interfaces.QuestionInterface[],
  setQuestions: (c: interfaces.QuestionInterface[]) => { },
  answers: [] as interfaces.AnswerInterface[],
  setAnswers: (c: interfaces.AnswerInterface[]) => { },
  toggleLockScreen: (l: boolean) => { }
});

const getClientPublishedStatus = function (client: interfaces.ClientInterface): boolean {
  if (!client || client?.id === undefined) return false

  return (client && (client.isPublished !== true || client.isLocked === true) && localStorage.getItem(`lockScreenEntered${client.id}`) === null)
}

export const ClientContextProvider = (props: { children: ReactChild | ReactChild[] }) => {
  const [client, setClient]: [interfaces.ClientInterface, (c: interfaces.ClientInterface) => void] = useState(
    {} as interfaces.ClientInterface
  );

  const [categories, setCategories]: [string[], (c: string[]) => void] = useState([] as string[]);
  const [questions, setQuestions]: [interfaces.QuestionInterface[], (c: interfaces.QuestionInterface[]) => void] = useState([] as interfaces.QuestionInterface[]);
  const [answers, setAnswers]: [interfaces.AnswerInterface[], (c: interfaces.AnswerInterface[]) => void] = useState([] as interfaces.AnswerInterface[]);

  const [clientIsNotPublished, toggleLockScreen] = useState(getClientPublishedStatus(client));

  useEffect(() => {
    if (client?.id) document.body.setAttribute('class', 'active');

    toggleLockScreen(getClientPublishedStatus(client))
  }, [client, clientIsNotPublished])

  setClients(client)

  return (
    <ClientContext.Provider value={{ client, setClient, categories, setCategories, questions, setQuestions, answers, setAnswers, toggleLockScreen }}>
      <>
        <LockScreen visible={clientIsNotPublished} clientId={client?.id} toggle={toggleLockScreen} />
        {props.children}
      </>
    </ClientContext.Provider>
  );
};

export const useClientContext = () => useContext(ClientContext);
